/************************************** COMMON ****************************/
export const APP_LOAD = 'APP_LOAD'
export const REDIRECT = 'REDIRECT'
export const ASYNC_START = 'ASYNC_START'
export const ASYNC_END = 'ASYNC_END'
export const CONFIRM_REDIRECT_TO = 'CONFIRM_REDIRECT_TO'
export const CLEAR_CONFIRM_REDIRECT_TO = 'CLEAR_CONFIRM_REDIRECT_TO'
export const CLEAR_REDIRECT = 'CLEAR_REDIRECT'
export const GRAPH_LOAD = 'GRAPH_LOAD'
export const BOOK_LOAD = 'BOOK_LOAD'
export const TRANSACTION_STATS_LOAD = 'TRANSACTION_STATS_LOAD'
export const PENDING = 'PENDING'
/************************************** COMMON ****************************/

/************************************** HOME PAGE ****************************/
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED'
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED'

/************************************** HOME PAGE ****************************/

/************************************** AUTH ****************************/
export const VERIFY_USER_INFO = 'VERIFY_USER_INFO'
export const REGISTER = 'REGISTER'
export const REGISTER_ISSUER = 'REGISTER_ISSUER'
export const REGISTER_PAGE_GETPINCODE = 'REGISTER_PAGE_GETPINCODE'
export const REGISTER_GO = 'REGISTER_GO'
export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const PHONE_LOGIN_GET_PINCODE = 'PHONE_LOGIN_GET_PINCODE'
export const PHONE_LOGIN_PAGE_LOADED = 'PHONE_LOGIN_PAGE_LOADED'
export const PHONE_LOGIN_PAGE_UNLOADED = 'PHONE_LOGIN_PAGE_UNLOADED'
export const GET_PIN_CODE = 'GET_PIN_CODE'
export const LOGIN_PAGE_VERIFY_PIN_CODE = 'LOGIN_PAGE_VERIFY_PIN_CODE'
export const VERIFY_PIN_CODE_UNLOADED = 'VERIFY_PIN_CODE_UNLOADED'
export const PHONE_LOGIN_SUBMIT = 'PHONE_LOGIN_SUBMIT'
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED'
export const LOGIN_GO = 'LOGIN_GO'

export const FORGOTPASSWORD = 'FORGOTPASSWORD'
export const RESETPASSWORD = 'RESETPASSWORD'
export const RESETPASSWORD_PAGE_UNLOADED = 'RESETPASSWORD_PAGE_UNLOADED'
export const FORGOTPASSWORD_UNLOADED = 'FORGOTPASSWORD_UNLOADED'
/************************************** AUTH ****************************/

/************************************** SETTINGS - PROFILE ****************************/
export const QRCODE_PAGE_LOADED = 'QRCODE_PAGE_LOADED'
export const QRCODE_PAGE_UNLOADED = 'QRCODE_PAGE_UNLOADED'
export const MY_DETAIL_PAGE_UNLOADED = 'MY_DETAIL_PAGE_UNLOADED'
export const MY_DETAIL_SUBMITTED = 'MY_DETAIL_SUBMITTED'
export const SEND_VERIFICATION_EMAIL = 'SEND_VERIFICATION_EMAIL'
export const BTCQRCODE_PAGE_LOADED = 'BTCQRCODE_PAGE_LOADED'
export const ETHQRCODE_PAGE_LOADED = 'ETHQRCODE_PAGE_LOADED'
export const CHANGE_PASSWORD_SUBMITTED = 'CHANGE_PASSWORD_SUBMITTED'
export const CHANGE_PASSWORD_UNLOADED = 'CHANGE_PASSWORD_UNLOADED'
export const CHANGE_PHONE_SUBMITTED = 'CHANGE_PHONE_SUBMITTED'
export const CHANGE_PHONE_UNLOADED = 'CHANGE_PHONE_UNLOADED'
export const CHANGE_PHONE_GETPINCODE = 'CHANGE_PHONE_GETPINCODE'
export const CHANGE_AVATAR_SUBMITTED = 'CHANGE_AVATAR_SUBMITTED'
export const CHANGE_AVATAR_UNLOADED = 'CHANGE_AVATAR_UNLOADED'
export const VERIFYID_PAGE_LOADED = 'VERIFYID_PAGE_LOADED'
export const VERIFYID_SUBMITTED = 'VERIFYID_SUBMITTED'
export const VERIFYID_PAGE_UNLOADED = 'VERIFYID_PAGE_UNLOADED'
export const SECURITY_PAGE_LOADED = 'SECURITY_PAGE_LOADED'
export const SECURITY_PAGE_UNLOADED = 'SECURITY_PAGE_UNLOADED'
export const UPDATE_SECURITY = 'UPDATE_SECURITY'
export const TOTP_PAGE_LOADED = 'TOTP_PAGE_LOADED'
export const TOTP_PAGE_UNLOADED = 'TOTP_PAGE_UNLOADED'
export const TOTP_SUBMIT = 'TOTP_SUBMIT'
export const REFRESH_TOKEN_VERSION = 'REFRESH_TOKEN_VERSION'
export const EVENTS_PAGE_LOADED = 'EVENTS_PAGE_LOADED'
export const EVENTS_PAGE_UNLOADED = 'EVENTS_PAGE_UNLOADED'
/************************************** SETTINGS - PROFILE ****************************/

/************************************** ASSET ****************************/
export const ASSET_CREATE = 'ASSET_CREATE'
export const ASSET_CREATE_PAGE_LOADED = 'ASSET_CREATE_PAGE_LOADED'
export const ASSET_CREATE_PAGE_UNLOADED = 'ASSET_CREATE_PAGE_UNLOADED'
export const ASSET_UPDATE = 'ASSET_UPDATE'
export const ASSET_UPDATE_PAGE_UNLOADED = 'ASSET_UPDATE_PAGE_UNLOADED'
export const ASSET_LIST_PAGE_LOADED = 'ASSET_LIST_PAGE_LOADED'
export const ASSET_LIST_PAGE_UNLOADED = 'ASSET_LIST_PAGE_UNLOADED'
export const ASSET_DETAIL_PAGE_LOADED = 'ASSET_DETAIL_PAGE_LOADED'
export const ASSET_DETAIL_PAGE_UNLOADED = 'ASSET_DETAIL_PAGE_UNLOADED'
/************************************** ASSET ****************************/

/************************************** TOKENS ****************************/
export const TOKEN_LIST_PAGE_LOADED = 'TOKEN_LIST_PAGE_LOADED'
export const TOKEN_LIST_PAGE_UNLOADED = 'TOKEN_LIST_PAGE_UNLOADED'
export const TOKEN_DETAIL_PAGE_LOADED = 'TOKEN_DETAIL_PAGE_LOADED'
export const TOKEN_DETAIL_PAGE_UNLOADED = 'TOKEN_DETAIL_PAGE_UNLOADED'
/************************************** TOKENS ****************************/

/************************************** ACCOUNTS ****************************/

export const ACCOUNT_GO = 'ACCOUNT_GO'
export const ACCOUNT_LIST_PAGE_LOADED = 'ACCOUNT_LIST_PAGE_LOADED'
export const ACCOUNT_LIST_PAGE_UNLOADED = 'ACCOUNT_LIST_PAGE_UNLOADED'

export const ACCOUNT_DETAIL_PAGE_LOADED = 'ACCOUNT_DETAIL_PAGE_LOADED'
export const ACCOUNT_DETAIL_PAGE_UNLOADED = 'ACCOUNT_DETAIL_PAGE_UNLOADED'
export const ACCOUNT_DETAIL_NEXT_PAGE_LOADED = 'ACCOUNT_DETAIL_NEXT_PAGE_LOADED'

export const SEND_LOADED = 'SEND_LOADED'
export const SEND_UNLOADED = 'SEND_UNLOADED'
export const SEND_FUNDS = 'SEND_FUNDS'

export const DEPOSIT_ETH_LOADED = 'DEPOSIT_ETH_LOADED'
export const DEPOSIT_ETH_UNLOADED = 'DEPOSIT_ETH_UNLOADED'
export const DEPOSIT_BTC_LOADED = 'DEPOSIT_BTC_LOADED'
export const DEPOSIT_BTC_UNLOADED = 'DEPOSIT_BTC_UNLOADED'
export const WITHDRAW_ETH_LOADED = 'WITHDRAW_ETH_LOADED'
export const WITHDRAW_ETH = 'WITHDRAW_ETH'
export const WITHDRAW_ETH_UNLOADED = 'WITHDRAW_ETH_UNLOADED'
export const WITHDRAW_BTC_LOADED = 'WITHDRAW_BTC_LOADED'
export const WITHDRAW_BTC = 'WITHDRAW_BTC'
export const WITHDRAW_BTC_UNLOADED = 'WITHDRAW_BTC_UNLOADED'
export const WITHDRAW_GET_TRANS_FEE = 'WITHDRAW_GET_TRANS_FEE'

/************************************** ACCOUNTS ****************************/

/************************************** TRADES ****************************/
export const TRADE_PAGE_LOADED = 'TRADE_PAGE_LOADED'
export const TRADE_PAGE_UNLOADED = 'TRADE_PAGE_UNLOADED'
export const CREATE_TRADE = 'CREATE_TRADE'

export const ORDER_LIST_PAGE_LOADED = 'ORDER_LIST_PAGE_LOADED'
export const ORDER_LIST_NEXT_PAGE_LOADED = 'ORDER_LIST_NEXT_PAGE_LOADED'
export const ORDER_LIST_PAGE_FILTER_LOADED = 'ORDER_LIST_PAGE_FILTER_LOADED'
export const ORDER_DETAIL_PAGE_LOADED = 'ORDER_DETAIL_PAGE_LOADED'
export const ORDER_DETAIL_PAGE_UNLOADED = 'ORDER_DETAIL_PAGE_UNLOADED'
export const CANCEL_ORDER = 'CANCEL_ORDER'

export const FEES_PAGE_LOADED = 'FEES_PAGE_LOADED'
export const FEES_PAGE_UNLOADED = 'FEES_PAGE_UNLOADED'
export const GET_ESTIMATE_FEE = 'GET_ESTIMATE_FEE'
export const UPDATE_TRADE_AMOUNT_PRICE = 'UPDATE_TRADE_AMOUNT_PRICE'
export const CANCEL_TO_CREATE_ORDER = 'CANCEL_TO_CREATE_ORDER'
/************************************** TRADES ****************************/

/************************************** TRANSACTIONS ****************************/
export const TRANSACTION_DETAIL_PAGE_LOADED = 'TRANSACTION_DETAIL_PAGE_LOADED'
export const TRANSACTION_DETAIL_PAGE_UNLOADED = 'TRANSACTION_DETAIL_PAGE_UNLOADED'

export const COIN_TRANSACTION_GO = 'COIN_TRANSACTION_GO'
/************************************** TRANSACTIONS ****************************/

/************************************** NEWS ****************************/
export const NEWS_CREATE = 'NEWS_CREATE'
export const NEWS_CREATE_PAGE_LOADED = 'NEWS_CREATE_PAGE_LOADED'
export const NEWS_CREATE_PAGE_UNLOADED = 'NEWS_CREATE_PAGE_UNLOADED'
export const NEWS_UPDATE = 'NEWS_UPDATE'
export const NEWS_UPDATE_PAGE_UNLOADED = 'NEWS_UPDATE_PAGE_UNLOADED'
export const NEWS_LIST_PAGE_LOADED = 'NEWS_LIST_PAGE_LOADED'
export const NEWS_LIST_PAGE_UNLOADED = 'NEWS_LIST_PAGE_UNLOADED'
export const NEWS_DETAIL_PAGE_LOADED = 'NEWS_DETAIL_PAGE_LOADED'
export const NEWS_DETAIL_PAGE_UNLOADED = 'NEWS_DETAIL_PAGE_UNLOADED'
export const NEWS_DELETE = 'NEWS_DELETE'
/************************************** NEWS ****************************/

/************************************** CERTIFICATE ****************************/
export const CERTIFICATE_ADD_PAGE_LOADED = 'CERTIFICATE_ADD_PAGE_LOADED'
export const CERTIFICATE_ADD_PAGE_UNLOADED = 'CERTIFICATE_ADD_PAGE_UNLOADED'
export const CERTIFICATE_ADD = 'CERTIFICATE_ADD'
export const CLEAR_CERTIFICATE_ADD_PROPS = 'CLEAR_CERTIFICATE_ADD_PROPS'
export const CERTIFICATE_LIST_PAGE_LOADED = 'CERTIFICATE_LIST_PAGE_LOADED'
export const CERTIFICATE_LIST_PAGE_UNLOADED = 'CERTIFICATE_LIST_PAGE_UNLOADED'
export const CERTIFICATE_DETAIL_PAGE_LOADED = 'CERTIFICATE_DETAIL_PAGE_LOADED'
export const CERTIFICATE_DETAIL_PAGE_UNLOADED = 'CERTIFICATE_DETAIL_PAGE_UNLOADED'
export const ISSUER_DETAIL_PAGE_LOADED = 'ISSUER_DETAIL_PAGE_LOADED'
export const ISSUER_UPDATE = 'ISSUER_UPDATE'
export const ISSUER_DETAIL_PAGE_UNLOADED = 'ISSUER_DETAIL_PAGE_UNLOADED'
export const ISSUER_DETAIL_LOGS_LOADED = 'ISSUER_DETAIL_LOGS_LOADED'
export const ACCOUNT_SUBSCRIBE = 'ACCOUNT_SUBSCRIBE'
export const UPDATE_CERTIFICATE_VIEWS = 'UPDATE_CERTIFICATE_VIEWS'
export const CERTIFICATE_FILE_UPLOADED = 'CERTIFICATE_FILE_UPLOADED'
export const CERTIFICATE_PENDING_LIST_PAGE_LOADED = 'CERTIFICATE_PENDING_LIST_PAGE_LOADED'
export const CERTIFICATE_PENDING_LIST_PAGE_UNLOADED = 'CERTIFICATE_PENDING_LIST_PAGE_UNLOADED'
export const CERTIFICATE_BULK_CREATE = 'CERTIFICATE_BULK_CREATE'
export const REMOVE_PENDING_CERTIFICATE = 'REMOVE_PENDING_CERTIFICATE'
/************************************** CERTIFICATE ****************************/

/************************************** FILES ****************************/
export const FILE_UPLOAD_PAGE_LOADED = 'FILE_UPLOAD_PAGE_LOADED'
export const FILE_UPLOAD_PAGE_UNLOADED = 'FILE_UPLOAD_PAGE_UNLOADED'
export const FILE_UPLOAD = 'FILE_UPLOAD'
export const FILE_LIST_PAGE_LOADED = 'FILE_LIST_PAGE_LOADED'
export const FILE_LIST_PAGE_UNLOADED = 'FILE_LIST_PAGE_UNLOADED'
export const FILE_DETAIL_PAGE_LOADED = 'FILE_DETAIL_PAGE_LOADED'
export const FILE_DETAIL_PAGE_UNLOADED = 'FILE_DETAIL_PAGE_UNLOADED'
export const FILE_DELETE = 'FILE_DELETE'
export const FILE_DOWNLOAD = 'FILE_DOWNLOAD'
export const FILE_PERMISSIONS_UPDATE = 'FILE_PERMISSIONS_UPDATE'

export const DIRECTORY_LIST_PAGE_LOADED = 'DIRECTORY_LIST_PAGE_LOADED'
export const DIRECTORY_LIST_PAGE_UNLOADED = 'DIRECTORY_LIST_PAGE_UNLOADED'

export const DIRECTORY_ADD_PAGE_LOADED = 'DIRECTORY_ADD_PAGE_LOADED'
export const DIRECTORY_ADD_PAGE_UNLOADED = 'DIRECTORY_ADD_PAGE_UNLOADED'
export const DIRECTORY_ADD = 'DIRECTORY_ADD'

export const DIRECTORY_UPDATE_PAGE_LOADED = 'DIRECTORY_UPDATE_PAGE_LOADED'
export const DIRECTORY_UPDATE_PAGE_UNLOADED = 'DIRECTORY_UPDATE_PAGE_UNLOADED'
export const DIRECTORY_UPDATE = 'DIRECTORY_UPDATE'
export const DIRECTORY_REMOVE = 'DIRECTORY_REMOVE'
export const LOG_LIST_PAGE_LOADED = 'LOG_LIST_PAGE_LOADED'
export const LOG_LIST_PAGE_UNLOADED = 'LOG_LIST_PAGE_UNLOADED'

export const GROUP_LIST_PAGE_LOADED = 'GROUP_LIST_PAGE_LOADED'
export const GROUP_LIST_PAGE_UNLOADED = 'GROUP_LIST_PAGE_UNLOADED'
export const GROUP_ADD = 'GROUP_ADD'
export const GROUP_DETAIL_PAGE_LOADED = 'GROUP_DETAIL_PAGE_LOADED'
export const GROUP_DETAIL_PAGE_UNLOADED = 'GROUP_DETAIL_PAGE_UNLOADED'
export const GROUP_UPDATE = 'GROUP_UPDATE'
export const GROUP_REMOVE = 'GROUP_REMOVE'
export const GROUP_ASSIGN_USER = 'GROUP_ASSIGN_USER'
export const GROUP_REMOVE_USER = 'GROUP_REMOVE_USER'
/************************************** FILES ****************************/